// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import './AccountSettingsPageTitle.scss'
import { PrimaryButton } from 'ui_kit_qmd'
import { useSelector } from 'react-redux'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import {
  ACCOUNT_SETTINGS_EDIT_ACCOUNT_TAB_PAGE_TITLE,
  ACCOUNT_SETTINGS_EDIT_SECURITY_TAB_PAGE_TITLE,
  ACCOUNT_SETTINGS_NOT_EDIT_MODE_PAGE_TITLE,
} from '../../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const AccountSettingsPageTitle = ({ isEditMode, onCancelBtnClicked, onSafeBtnClicked }) => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const tabs = useSelector((state) => state.accountSettings.tabs)
  const [pageTitle, setPageTitle] = useState('Account settings')

  useEffect(() => {
    if (isEditMode && tabs) {
      if (tabs[0].isActive) {
        setPageTitle(ACCOUNT_SETTINGS_EDIT_ACCOUNT_TAB_PAGE_TITLE)
      }
      if (tabs[1].isActive) {
        setPageTitle(ACCOUNT_SETTINGS_EDIT_SECURITY_TAB_PAGE_TITLE)
      }
    } else {
      setPageTitle(ACCOUNT_SETTINGS_NOT_EDIT_MODE_PAGE_TITLE)
    }
  }, [isEditMode, tabs])

  const cancelBtnContainerStyle = {
    height: 40,
    width: 200,
    border: '1px solid #00A2B2',
    padding: 0,
  }
  const saveBtnContainerStyle = {
    height: 40,
    width: 200,
    marginLeft: 32,
  }
  const cancelBtnLabelStyle = {
    fontSize: 20,
    fontWeight: 700,
    gap: 10,
    letterSpacing: 1.5,
  }
  const saveBtnLabelStyle = {
    fontSize: 20,
    gap: 10,
    letterSpacing: 1.5,
  }
  const settingsPageTitleAdditionalStyle = {
    marginBottom: isEditMode ? 66 : 60,
  }

  return (
    <div className='settings-page-title-wrapper'>
      <div style={settingsPageTitleAdditionalStyle} className='settings-page-title'>
        {pageTitle}
      </div>
      {isEditMode ?
        <div className='settings-edit-made-btn-block'>
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <SecondaryButton
            id='viewServiceCancelEditBtn'
            btnText='Cancel'
            containerStyle={cancelBtnContainerStyle}
            labelStyle={cancelBtnLabelStyle}
            onPress={onCancelBtnClicked}
          />
          <PrimaryButton
            btnText='Save'
            id='viewServiceSaveEditBtn'
            containerStyle={saveBtnContainerStyle}
            labelStyle={saveBtnLabelStyle}
            onPress={onSafeBtnClicked}
          />
        </div>
      : null}
    </div>
  )
}

export default AccountSettingsPageTitle
